import { Component, OnInit, Input } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'insight-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
  imports: [MatProgressSpinner]
})
export class LoadingSpinnerComponent implements OnInit {
  @Input() loadingMessage: string;

  ngOnInit() { }
}
